module.exports = __webpack_public_path__ + "img/shidi.0e012ab1.png";